import {configureStore} from '@reduxjs/toolkit'
import CampanhaService from './services/CampanhaService'
import InternacionalizacaoService from './services/Internacionalizacao'

const campanhaService = new CampanhaService()

const initialState = {
    i18n: new InternacionalizacaoService()
};

if (campanhaService.campanhaCorrente()) {
    initialState.i18n.load()
}

function weexReducer(state = initialState, action) {
    switch (action.type) {
        case 'campanha/selecionar':
            
            let internacional = new InternacionalizacaoService()
            internacional.load()
            return {i18n:internacional}
    }
    return state
}

export default configureStore({
    reducer:weexReducer
})